import React from 'react';
import Modal from '../../../../react-component/modal';

import { Text, TextInputNative, ErrorText, ErrorContainer } from '../styles';

export const ModalCadastroUsuario = ({
    saveUser,
    setModalCadastroVisible,
    setEmail,
    email,
    isLoading,
    errorMessage
}) => {
    return (
        <Modal
            title={'Cadastrar usuário'}
            saveText="Cadastrar"
            onSave={saveUser}
            onClose={() => {
                setModalCadastroVisible(false);
                setEmail('');
            }}
            isSaveButtonLoading={isLoading}
        >
            <Text>Email</Text>
            <TextInputNative
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ex: usuario@exemplo.com"
            />
            {errorMessage && (
                <ErrorContainer>
                    <ErrorText>{errorMessage}</ErrorText>
                </ErrorContainer>
            )}
        </Modal>
    );
};
